/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_SyncInputs */

const cs_projects_sync = /** @type {(inputs: Projects_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizovat na Sreality`)
};

const en_projects_sync = /** @type {(inputs: Projects_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync to Sreality`)
};

/**
* | output |
* | --- |
* | "Sync to Sreality" |
*
* @param {Projects_SyncInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_sync = /** @type {((inputs?: Projects_SyncInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_SyncInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_sync(inputs)
	return cs_projects_sync(inputs)
});